import React, { useEffect, useState } from 'react';
import { TbX } from 'react-icons/tb';
import Badge from '../Badge';
import { useTranslation } from 'react-i18next';
import Img from '../Img';

type Filter = {
    id: number;
    name: string;
    slug: string;
    icon: string | null;
};

interface ProductsFilterChipsProps {
    selectedFilters: any;
    className?: string;
    onRemoveFilter: (filterId: number) => void;
    onResetFilters?: () => void;
}

const ProductsFilterChips = ({
    selectedFilters,
    className,
    onRemoveFilter,
    onResetFilters,
}: ProductsFilterChipsProps) => {

    const { t } = useTranslation();
    const [filters, setFilters] = useState<Filter[]>([]);

    useEffect(() => {
        setFilters(selectedFilters ? selectedFilters : []);
    }, [selectedFilters]);

    if (filters.length === 0) return null;

    return (
        <div className={`flex items-center flex-wrap gap-1 ${className ?? ''}`}>
            {filters.map(filter => (
                <button
                    key={`${filter.id}-chips`}
                    className='cursor-pointer leading-none'
                    onClick={() => onRemoveFilter(filter.id)}
                    >
                    <Badge type='tag'>
                        {filter.icon &&
                            <Img
                                alt={filter.name}
                                title={filter.name}
                                className="w-3 h-3"
                                src={filter.icon}
                            />
                        }
                        {filter.name}
                        <TbX size={12} />
                    </Badge>
                </button>
            ))}
            {onResetFilters && (
                <button
                    onClick={() => onResetFilters()}
                    className={`leading-none`}
                    >
                    <Badge outline type='tag' className={`pr-1 normal-case w-max ring-white`}>
                        {t('products.filters.reset_filter_label')}
                        <div className='p-0.5 cursor-pointer rounded-full'><TbX size={12} /></div>
                    </Badge>
                </button>
            )}
        </div>
    );
};

export default ProductsFilterChips;